import {
  Action,
  ActionType,
} from "models/stressCheck/miniStressSendNotification";
import { IResponse } from "models";

import createReducer from "redux/createReducer";

export interface SendMiniStressNotificationReducerType {
  loading: boolean;
  error?: any;
  saved: boolean;
  sendMiniStressNotificationResponse?: IResponse;
}

const defaultState: SendMiniStressNotificationReducerType = {
  loading: false,
  error: null,
  saved: false,
  sendMiniStressNotificationResponse: undefined,
};

export const sendMiniStressNotificationReducer =
  createReducer<SendMiniStressNotificationReducerType>(defaultState, {
    [ActionType.SEND_MINI_NOTIFICATION](
      state: SendMiniStressNotificationReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.SEND_MINI_NOTIFICATION_ERROR](
      state: SendMiniStressNotificationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: action.payload,
      };
    },

    [ActionType.SEND_MINI_NOTIFICATION_SUCCESS](
      state: SendMiniStressNotificationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        sendMiniStressNotificationResponse: action.payload,
      };
    },

    [ActionType.RESET_SEND_MINI_NOTIFICATION](
      state: SendMiniStressNotificationReducerType
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: null,
        sendMiniStressNotificationResponse: undefined,
      };
    },
  });
